module.exports = __webpack_public_path__ + "static/img/bot1.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bot1.png
// module id = h79w
// module chunks = 31